export default __webpack_public_path__ + "static/media/sn1.77e7a842.jpg";